import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@mdi/font/css/materialdesignicons.css'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { setHeadersProvider, setOnUnauthorized } from './services/api'
import { loadClients } from './config/clients'
import { useSessionStore } from './stores/session'
import { useAuthStore } from './stores/auth'
import { reauthenticate } from './services/auth'
import './styles/main.scss'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(vuetify)

const session = useSessionStore()
const auth = useAuthStore()

setHeadersProvider(() => {
  const headers: Record<string, string> = {}
  if (session.accId) {
    headers['x-ax-workspace'] = session.accId
  }
  if (session.supplierHeader) {
    headers['x-ax-supplier'] = session.supplierHeader
  }
  return headers
})

// Un 401 es token vencido o invalido, no una sesion que haya que cerrar: se re-loguea en la
// misma ruta (transparente si el SSO sigue vivo). Tampoco se limpia la sesion del portal: el
// proveedor seleccionado debe seguir ahi al volver.
setOnUnauthorized(() => {
  if (reauthenticate(window.location.pathname + window.location.search)) {
    auth.clear()
  }
})

// El mapeo de clientes viene de Keycloak y las rutas dependen de el. OJO: en vue-router 4 la
// navegacion inicial se dispara al INSTALAR el router (app.use), no al montar, asi que el
// router se instala recien cuando el mapa esta cargado (el guard resuelve el cliente del path
// de forma sincrona sobre el mapa en memoria).
loadClients()
  .catch((err) => console.error('No se pudo cargar el mapeo de clientes del portal:', err))
  .finally(() => {
    app.use(router)
    app.mount('#app')
  })
